import React from 'react';

const SlackLogo = props => (
  <svg width={32} height={32} {...props}>
    <g fill="none">
      <path
        d="M20.63 2.107a2.851 2.851 0 0 0-3.563-1.82 2.851 2.851 0 0 0-1.821 3.563l7.31 22.478a2.821 2.821 0 0 0 3.434 1.744c1.51-.443 2.42-2.03 1.925-3.487 0-.052-7.284-22.478-7.284-22.478z"
        fill="#ECB32D"
      />
      <path
        d="M9.314 5.776A2.851 2.851 0 0 0 5.75 3.954 2.851 2.851 0 0 0 3.928 7.52l7.311 22.478a2.821 2.821 0 0 0 3.434 1.743c1.51-.442 2.42-2.03 1.925-3.486 0-.052-7.284-22.478-7.284-22.478z"
        fill="#63C1A0"
      />
      <path
        d="M29.84 20.709a2.851 2.851 0 0 0 1.822-3.564 2.851 2.851 0 0 0-3.564-1.821L5.593 22.66a2.821 2.821 0 0 0-1.743 3.434c.443 1.51 2.03 2.42 3.487 1.926.052 0 22.504-7.311 22.504-7.311z"
        fill="#E01A59"
      />
      <path
        d="M10.276 27.083c1.457-.468 3.357-1.093 5.386-1.743-.469-1.457-1.093-3.356-1.743-5.386l-5.386 1.744 1.743 5.385z"
        fill="#331433"
      />
      <path
        d="M21.62 23.389c2.029-.65 3.928-1.275 5.385-1.743-.468-1.457-1.093-3.357-1.743-5.386l-5.386 1.743 1.744 5.386z"
        fill="#D62027"
      />
      <path
        d="M26.146 9.392a2.851 2.851 0 0 0 1.821-3.564 2.851 2.851 0 0 0-3.564-1.821l-22.478 7.31a2.821 2.821 0 0 0-1.743 3.434c.442 1.51 2.03 2.42 3.486 1.925.052 0 22.478-7.284 22.478-7.284z"
        fill="#89D3DF"
      />
      <path
        d="M6.608 15.74c1.457-.468 3.356-1.093 5.385-1.743-.65-2.03-1.274-3.929-1.743-5.386l-5.385 1.743 1.743 5.386z"
        fill="#258B74"
      />
      <path
        d="M17.925 12.072c2.03-.65 3.929-1.275 5.386-1.744-.65-2.029-1.275-3.928-1.744-5.385l-5.385 1.743 1.743 5.386z"
        fill="#819C3C"
      />
    </g>
  </svg>
);

export default SlackLogo;



// WEBPACK FOOTER //
// ./src/javascripts/app/Webhooks/templates/logos/SlackLogo.es6.js